import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import { showPopupModal } from "@widgets/CommonModal";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import ExcelUpload from "@widgets/commonpopup/ExcelUpload";
import SN_QMS_BAS_REG_001_POP_001 from "./SN_QMS_BAS_REG_001_POP_001";
interface Props {
  Menuprops: menuInfo;
}

const SN_QMS_BAS_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const sheetRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    sheet1: [],
  });
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
          sheet1: rtn.grid.sheet1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_qms_bas_reg_001_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
        sheet1: data[0],
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    try {
      const searchInfo = searchRef.current.getFormdata();
      const newRow = {
        cd_firm: userInfo?.cd_firm,
        cd_biz: searchInfo?.cd_biz,
        yn_use: "Y",
        yn_insp: "Y",
        yn_sample: "Y",
        tp_insp: "QTT",
        yn_end: "Y",
        no_level: "1",
        no_seq: "1",
      }; // 빈 객체
      gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) {
      return;
    }

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return; // 사용자가 아니오를 선택하면 함수 종료
    }
    gridRefs.current["grid1"].current?.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
      gridRefs.current["grid1"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      // H 필수값 체크
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      const headerChanges = gridRefs.current["grid1"].current.getChange();
      const headerInserts = headerChanges.insert ?? [];
      if (headerInserts.length < 0) {
        await showDialog("alter", "저장에 실패했습니다.");
        return;
      }

      if (headerChanges.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();

      // 요청 데이터 구성
      const SaveData = {
        qms_clause: headerChanges,
      };
      // 저장 API 호출
      const ok = await fnSave("SN_QMS_BAS_REG_001_SAVE_01", SaveData);
      if (!ok) {
        return;
      }

      // 성공적으로 저장된 후 초기화
      gridRefs.current["grid1"].current.resetUpdate();
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
    }
  };
  const onCellDoubleClicked = async (event: any) => {
    const selectedData = gridRefs.current["grid1"].current.focusedRowNode();
    if (event.colDef.field === "txt_explain") {
      const component = (
        <SN_QMS_BAS_REG_001_POP_001 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "",
        children: component,
        validation: false,
        width: "20%",
        height: "30%",
        okayBtn: true,
        closeBtn: true,
        checkData: false, // 확인버튼 눌렀을때 error 안뜨게
      });
      if (!result || result === "close") return;
      setTimeout(() => {
        event.node.setDataValue("txt_explain", result[0], "noEvent");
      }, 0);
      gridRefs.current["grid1"].current?.stopEditing();
    }
  };
  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "yn_sample") {
      if (rowData.yn_sample === "Y") return;
      rowNode.setDataValue("cd_sample", "");
    }
  };
  const onExcelDownLoad = async () => {
    try {
      const displayedCols = sheetRef.current?.getAllDisplayedColumns() || [];
      const columnKeys = displayedCols.map((c: any) => c.getColId());
      sheetRef.current?.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}.xlsx`,
        sheetName: "Sheet1",
        processCellCallback: (params: any) => {
          if (
            params.column.getColId() === "yn_sample" ||
            params.column.getColId() === "yn_use" ||
            params.column.getColId() === "yn_insp"
          ) {
            return params.value ? "Y" : "N";
          }
          return params.value;
        },
      });
    } catch (e: any) {
      showDialog("error", e?.message || "Excel 다운로드 오류");
    }
  };
  const onExcelUpload = async () => {
    try {
      const component = (
        <ExcelUpload
          Menuprops={Menuprops} // 메뉴 정보 전달
          PkFields={["cd_firm,cd_clause"]} // PK 필드 목록 전달
          tableName="qms_clause" // 저장할 테이블 이름
          controllerName="SN_QMS_BAS_REG_001_SAVE_01" // 저장할 컨트롤러 이름
          defaultValue={{
            cd_biz: "1000",
            yn_end: "Y",
            cd_firm: userInfo.cd_firm,
          }}
          // userInfo={userInfo}
        />
      );

      const result = await showPopupModal({
        title: "엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "저장",
      });

      if (result?.excelUpload) {
        await onSearch();
      }

      if (result) {
        console.log("엑셀 업로드 완료:", result);
      } else {
        console.log("엑셀 업로드 취소됨");
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onCellValueChanged: onCellValueChanged,
          onCellDoubleClicked: onCellDoubleClicked,
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{ rowSelection: "multiple" }}
          events={grids.grid1.events}
          //chartColumns={["qt", "am"]}
        />
      </div>
      <div style={{ display: "none" }}>
        <SnGrid
          ref={sheetRef}
          columnConfig={grids.sheet1.columns}
          rowData={grids.sheet1.dataSource}
          etcProps={{ isEditable: false }}
        />
      </div>
    </div>
  );
});

export default SN_QMS_BAS_REG_001;
